var landscape = require("app/theme/assets/placeholder-landscape-notext.png"),
    portrait  = require("app/theme/assets/placeholder-portrait-notext.png"),
    square    = require("app/theme/assets/placeholder-square-notext.png");

module.exports = [
    // Landscape
    {
        width:        3840,
        height:       2160,
        aspect_ratio: 3840 / 2160,
        url:          landscape
    },

    // Portrait
    {
        width:        2717,
        height:       3840,
        aspect_ratio: 2717 / 3840,
        url:          portrait
    },

    // Square
    {
        width:        2560,
        height:       2560,
        aspect_ratio: 2560 / 2560,
        url:          square
    }
];
